import { render } from "./BlCollectionMove.vue?vue&type=template&id=583edf4e&scoped=true"
import script from "./BlCollectionMove.vue?vue&type=script&lang=js"
export * from "./BlCollectionMove.vue?vue&type=script&lang=js"

import "./BlCollectionMove.vue?vue&type=style&index=0&id=583edf4e&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583edf4e"]])

export default __exports__